import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '@gokrew/models/constants/query-keys';
import type { FulfilDocumentRequestPayload } from '@gokrew/models/documents';
import {
  fulfilDocumentRequest,
  getMyDocumentRequests,
} from '@/api/document-requests';

/** The documents HR asked me for. */
export function useMyDocumentRequests(enabled = true) {
  return useQuery({
    queryKey: [QueryKeys.DocumentRequests],
    queryFn: getMyDocumentRequests,
    enabled,
  });
}

/** Uploads against a request; my documents and the request list refetch. */
export function useFulfilDocumentRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      requestId,
      payload,
    }: {
      requestId: string;
      payload: FulfilDocumentRequestPayload;
    }) => fulfilDocumentRequest(requestId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QueryKeys.DocumentRequests],
      });
      void queryClient.invalidateQueries({
        queryKey: [QueryKeys.EmployeePortalDocuments],
      });
    },
  });
}
